// extracted by mini-css-extract-plugin
export default {"jobsContainer":"JobList_jobsContainer__48tI3","jobPostPreview":"JobList_jobPostPreview__VyWnm","jobLink":"JobList_jobLink__Yy491","wholeJobDiv":"JobList_wholeJobDiv__9VrXx"};